import React, { FC } from 'react'
import {
  MediumContent,
  LargeContent,
  SmallContent,
} from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/EarlyBirdBanner/index'
import {
  EarlyBirdValues,
  EarlyBirdValuesType,
} from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/config/EarlyBirdValues'

export interface EarlyBirdContentProps {
  theatricalSlug?: string
  className?: string
  code: string
  discount: number
  refetch: () => void
  bannerValues: EarlyBirdValuesType
}
interface EarlyBirdBannerProps {
  theatricalSlug: string
  className: string
  code: string
  discount: number
  refetch: () => void
}

export const EarlyBirdBanner: FC<EarlyBirdBannerProps> = ({ theatricalSlug, code, discount, refetch }) => {
  const bannerValues = EarlyBirdValues[theatricalSlug]
  return (
    <div className="relative z-[39] mb-2 min-h-[120px] @container @[328px]:min-h-[160px] @[732px]:min-h-[140px] ">
      <div className="relative hidden min-h-[160px] @[725px]:min-h-[140px] @[732px]:block">
        <LargeContent bannerValues={bannerValues} code={code} discount={discount} refetch={refetch} />
      </div>
      <div className="relative hidden min-h-[160px] @[516px]:block @[732px]:hidden">
        <MediumContent bannerValues={bannerValues} code={code} discount={discount} refetch={refetch} />
      </div>
      <div className="relative min-h-[120px]  @[516px]:hidden">
        <SmallContent bannerValues={bannerValues} code={code} discount={discount} refetch={refetch} />
      </div>
    </div>
  )
}
